// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 494 ? "6ca5b90f" : chunkId) + "." + {"494":"856dab179c8a3676","797":"ec98fb8849c731f0"}[chunkId] + ".js";
};